import React from 'react';

import { Grid, makeStyles, SvgIcon, Typography } from '@material-ui/core';

import { ReactComponent as UploadIcon } from '../../assets/images/ant-design_upload-outlined.svg';
import { ReactComponent as CardIcon } from '../../assets/images/bx_bx-credit-card-front.svg';
import { ReactComponent as VideoIcon } from '../../assets/images/ic_round-ondemand-video.svg';
import { usePackagePlanStyles } from '../payment/styles';

const useSvgStyles = makeStyles(() => {
  return {
    card: {
      height: '78px',
      width: '78px',
    },
    upload: {
      height: '75px',
      width: '75px',
    },
    video: {
      height: '72px',
      width: '72px',
    },
  };
});

export default () => {
  const classes = usePackagePlanStyles();
  const svgClasses = useSvgStyles();
  return (
    <div style={{ paddingBottom: '2rem', textAlign: 'center', width: '875px' }}>
      <Typography className="page-header" align="center">
        How it works
      </Typography>
      <Grid container className={classes.packageContainer} style={{ paddingTop: '10px' }}>
        <Grid container item alignItems="center" xs={4} className={classes.plan} justify="flex-start" direction="column">
          <SvgIcon component={CardIcon} viewBox="0 0 78 78" className={svgClasses.card} color="primary" />
          <Typography variant="subtitle1" className={classes.subtitle} style={{ width: '70%' }}>
            Add a method of payment
          </Typography>
        </Grid>
        <Grid container item alignItems="center" xs={4} className={classes.plan} justify="flex-start" direction="column">
          <SvgIcon component={UploadIcon} viewBox="0 0 75 75" className={svgClasses.upload} color="primary" />
          <Typography variant="subtitle1" className={classes.subtitle} style={{ width: '70%' }}>
            Upload your imaging study and radiology report
          </Typography>
        </Grid>
        <Grid container item alignItems="center" xs={4} className={classes.plan} justify="flex-start" direction="column">
          <SvgIcon component={VideoIcon} viewBox="0 0 72 72" className={svgClasses.video} color="primary" />
          <Typography variant="subtitle1" className={classes.subtitle} style={{ width: '70%' }}>
            We’ll notify you when your Video Report is ready and you can watch it on your personal online portal!
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};
